export class Manager {
  constructor({
    id,
    vorname,
    nachname,
  }: {
    id: string;
    vorname: string;
    nachname: string;
  }) {
    this.id = id;
    this.vorname = vorname;
    this.nachname = nachname;
  }

  id: string;
  vorname: string;
  nachname: string;
}
